import {
  AppStore,
  appStore,
  AuxillarySystemStore,
  auxillarySystemStore,
  DialogStore,
  dialogStore,
  FileSystemStore,
  fileSystemStore,
  Message,
  MessageStore,
  messageStore,
  MessageStyle,
  SettingsStore,
  settingsStore,
  SystemStore,
  systemStore,
  TerminalStore,
  terminalStore,
  UserStore,
  userStore,
} from '../store';
// TODO: Get rid of dependency on the order of imports. For now this import should go after the import from '../store'
import { changeWebRtcDisabled } from '../socket';

class MessageActions {
  private messageStore: MessageStore;

  constructor(messageStore: MessageStore) {
    this.messageStore = messageStore;
  }

  /** Killed process message. */
  processHasBeenKilled(process: KilledProcessInfo) {
    this.messageStore.handleMessage({
      style: 'success',
      text:
        'Process killed: ' +
        process.processName +
        ', ID: ' +
        process.processName,
    });
  }

  serviceHasBeenStarted(service: ServiceInfo) {
    this.messageStore.handleMessage({
      style: 'success',
      text: 'Service started: ' + service.serviceName,
    });
  }

  serviceFailedToStart(serviceActionError: ServiceActionError) {
    this.messageStore.handleMessage({
      style: 'danger',
      text: `Service '${serviceActionError.serviceName}' failed to start: ${
        serviceActionError.error
      }`,
    });
  }

  serviceHasBeenStopped(service: ServiceInfo) {
    this.messageStore.handleMessage({
      style: 'success',
      text: 'Service stopped: ' + service.serviceName,
    });
  }

  serviceFailedToStop(serviceActionError: ServiceActionError) {
    this.messageStore.handleMessage({
      style: 'danger',
      text: `Service '${serviceActionError.serviceName}' failed to stop: ${
        serviceActionError.error
      }`,
    });
  }

  serviceHasBeenRestarted(service: ServiceInfo) {
    this.messageStore.handleMessage({
      style: 'success',
      text: 'Service restarted: ' + service.serviceName,
    });
  }

  serviceFailedToRestart(serviceActionError: ServiceActionError) {
    this.messageStore.handleMessage({
      style: 'danger',
      text: `Service '${serviceActionError.serviceName}' failed to restart: ${
        serviceActionError.error
      }`,
    });
  }

  /** Message of type "info". */
  plainMessage(message: string) {
    this.messageStore.handleMessage({
      style: 'info',
      text: message,
    });
  }
  /** Custom message. Takes a full message object. */
  message(message: Message) {
    this.messageStore.handleMessage(message);
  }
  clearMessages() {
    this.messageStore.clearMessages();
  }
  /** Shorthand message, Style and text are just arguments. */
  msg(style: MessageStyle, text: string) {
    this.messageStore.handleMessage({ style, text });
  }
}

export const messageActions = new MessageActions(messageStore);

class DialogActions {
  private dialogStore: DialogStore;

  constructor(dialogStore: DialogStore) {
    this.dialogStore = dialogStore;
  }

  showDialog(dialog: DialogContent) {
    this.dialogStore.addDialog(dialog);
  }

  closeFirstDialog() {
    this.dialogStore.closeFirstDialog();
  }
}

/** Don't use this anymore. Use dialogEvents instead. */
export const dialogActions = new DialogActions(dialogStore);

class AppActions {
  private appStore: AppStore;

  constructor(appStore: AppStore) {
    this.appStore = appStore;
  }

  login(loggedIn: boolean) {
    this.appStore.handleLogin(loggedIn);
  }
  setPassword(password: string) {
    this.appStore.handleSetPassword(password);
  }
  setKey(key: string, iv: string) {
    this.appStore.handleSetKey({ key, iv });
  }
  setShake(shook: boolean) {
    this.appStore.handleSetShake(shook);
  }
  setHost(host: HostInfo) {
    this.appStore.handleSetHost(host);
  }
  setDebugMenu(enabled: boolean) {
    this.appStore.handleSetDebugMenu(enabled);
  }
  setRtc(available: boolean) {
    this.appStore.handleSetRtc(available);
  }
  setWebRtcDisabled(disabled: boolean) {
    changeWebRtcDisabled(disabled);
  }
}

/** Actions related to application state. */
export const appActions = new AppActions(appStore);

class SystemActions {
  private systemStore: SystemStore;
  private auxillarySystemStore: AuxillarySystemStore;
  private userStore: UserStore;

  constructor(
    systemStore: SystemStore,
    auxillarySystemStore: AuxillarySystemStore,
    userStore: UserStore,
  ) {
    this.systemStore = systemStore;
    this.auxillarySystemStore = auxillarySystemStore;
    this.userStore = userStore;
  }

  updateStats(stats: SystemInfo) {
    this.systemStore.handleUpdateStats(stats);
  }

  updateNet(net: NetworkInfo) {
    this.auxillarySystemStore.handleUpdateNet(net);
  }

  updateCPU(cpu: CpuInfo) {
    this.auxillarySystemStore.handleUpdateCpu(cpu);
  }

  updateOS(os: OSInfo) {
    this.auxillarySystemStore.handleUpdateOS(os);
  }

  updateGpu(gpu: GpusInfo) {
    this.auxillarySystemStore.handleUpdateGpu(gpu);
  }

  updateUser(user: UserInfo) {
    this.userStore.handleUpdateUser(user);
  }
}

/** Actions for updating system information. */
export const systemActions = new SystemActions(
  systemStore,
  auxillarySystemStore,
  userStore,
);

// TODO Camera isn't used anymore

// interface CameraActionFunctions {
//   updateCameras(cams: CameraInfos): CameraInfo[];
//   updateFrame(frame: CameraImage): CameraImage;
//   startCameraStream(Id: string): string;
//   stopCameraStream(Id: string): string;
// }

// class CameraActions extends AbstractActions {
//   updateCameras(cams: CameraInfos) {
//     return cams.cameraInfo;
//   }
//   updateFrame(frame: CameraImage) {
//     return frame;
//   }
//   startCameraStream(Id: string) {
//     return Id;
//   }
//   stopCameraStream(Id: string) {
//     return Id;
//   }
// }

// /** Shouldn't be used anymore. */
// export let cameraActions = alt.createActions<CameraActionFunctions>(
//   CameraActions,
// );

class SettingsActions {
  private settingsStore: SettingsStore;

  constructor(settingsStore: SettingsStore) {
    this.settingsStore = settingsStore;
  }

  updateSetting = (setting: any) => this.settingsStore.updateSetting(setting);

  updateAllSettings = (allSettings: SettingsInfo.All) =>
    this.settingsStore.updateAllSettings(allSettings);
}

/** Settings panel is gone. */
export const settingsActions = new SettingsActions(settingsStore);

class FileSystemActions {
  private fileSystemStore: FileSystemStore;

  constructor(fileSystemStore: FileSystemStore) {
    this.fileSystemStore = fileSystemStore;
  }

  updateFileTree = (tree: FileSystemInfo.FileTree) => {
    this.fileSystemStore.handleUpdateFileTree(tree);
  };

  createRoot = (drives: DriveInfo[]) => {
    this.fileSystemStore.handleCreateRoot(drives);
  };

  reloadFileTree = (tree: FileSystemInfo.FileTree) => {
    this.fileSystemStore.handleReload(tree);
  };

  addDownload = (file: FileTransfer.Initial) => {
    this.fileSystemStore.handleAddDownload(file);
  };

  downloadProgress = (data: FileTransfer.Progress) => {
    this.fileSystemStore.handleDownloadProgress(data);
  };

  uploadProgress = (file: FileTransfer.UploadProgress) => {
    this.fileSystemStore.handleUploadProgress(file);
  };

  downloadComplete = (data: FileTransfer.Complete) => {
    this.fileSystemStore.handleDownloadComplete(data);
  };

  removeDownload = (path: string) => {
    this.fileSystemStore.handleRemoveDownload(path);
  };

  search = (result: SearchResult) => {
    this.fileSystemStore.handleSearch(result);
  };

  clearSearch = () => {
    this.fileSystemStore.handleClearSearch();
  };

  goBack = () => {
    this.clearSearch();
    this.fileSystemStore.setIsLoadingFiles(true);
    this.fileSystemStore.handleBack();
  };

  goForward = () => {
    this.clearSearch();
    this.fileSystemStore.setIsLoadingFiles(true);
    this.fileSystemStore.handleForward();
  };
}

/** Actions related to the filesystem. All just straightforward passthroughs. */
export const fileSystemActions = new FileSystemActions(fileSystemStore);

// TODO Plugins isn't used anymore

// interface PluginActionFunctions {
//   updatePlugins(plugins: PluginInfo.Plugins): PluginInfo.Plugins;
//   startPlugin(plugin: PluginInfo.Started): PluginInfo.Started;
// }

// class PluginActions extends AbstractActions {
//   // constructor(alt: AltJS.Alt) {
//   //   super(alt);
//   //   this.generateActions('updatePlugins', 'startPlugin');
//   // }
// }

// export let pluginActions = alt.createActions<PluginActionFunctions>(
//   PluginActions,
// );

class TerminalActions {
  private terminalStore: TerminalStore;

  constructor(terminalStore: TerminalStore) {
    this.terminalStore = terminalStore;
  }

  addTerminal(descriptor: TerminalInfo.Terminal): void {
    this.terminalStore.handleAddTerminal(descriptor);
  }

  removeTerminal(id: string): void {
    this.terminalStore.handleRemoveTerminal(id);
  }

  output(content: TerminalInfo.Output): void {
    this.terminalStore.handleOutput(content);
  }

  sendCommand(content: TerminalInfo.SendCommand): void {
    this.terminalStore.handleSendCommand(content);
  }

  autocomplete(autocompleteData: TerminalInfo.AutocompleteData) {
    this.terminalStore.handleAutocomplete(autocompleteData);
  }

  expectTerminal() {
    this.terminalStore.handleExpectTerminal();
  }

  cancelExpectTerminal() {
    this.terminalStore.cancelExpectTerminal();
  }

  changeCommand(id: string, command: string) {
    this.terminalStore.handleChangeCommand([id, command]);
  }

  goBack(id: string) {
    this.terminalStore.handleGoBack(id);
  }

  goForward(id: string) {
    this.terminalStore.handleGoForward(id);
  }

  resetAutocomplete(id: string) {
    this.terminalStore.handleResetAutocomplete(id);
  }
}

export const terminalActions = new TerminalActions(terminalStore);

// Scripts isn't used anymore

// interface ScriptActionFunctions {
//   getAllJobs(jobs: ScriptInfo.Scripts): ScriptInfo.Scripts;
//   mergeFromServer(newScript: ScriptInfo.FullScript): ScriptInfo.FullScript;
//   mergeLocally(script: ScriptInfo.FullScript): ScriptInfo.FullScript;
//   getDaemonStatus(running: boolean): boolean;
//   setActive(activeScript: string): string;
//   remove(guid: string): string;
// }

// class ScriptActions extends AbstractActions {
//   constructor(alt: AltJS.Alt) {
//     super(alt);
//     this.generateActions(
//       'getAllJobs',
//       'mergeFromServer',
//       'mergeLocally',
//       'getDaemonStatus',
//       'setActive',
//       'remove',
//     );
//   }
// }

// /** Actions for updating scripts. */
// export let scriptActions = alt.generateActions<ScriptActionFunctions>(
//   'getAllJobs',
//   'mergeFromServer',
//   'mergeLocally',
//   'getDaemonStatus',
//   'setActive',
//   'remove',
// );
